// extracted by mini-css-extract-plugin
module.exports = {"toast":"style_toast__jQkUe"};